export default "__VITE_ASSET__1805585d__"